import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools';

import { getGlobalAppsParams } from './getGlobalAppsParams';

export const preloadGlobalApps = async () => {
	const { edition, accessStatus } = await getPreloaderFnContext();

	const { webItemParams, forgeExtensionParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	return Promise.all([
		preloadWebItemLocation(webItemParams),
		preloadUseExtensionList(forgeExtensionParams),
	]);
};
